import { PropTypes } from 'prop-types';
import { useCallback, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const mount = document.querySelector('.site-footer__network-nav ul')
  || document.querySelector('.site-footer__network-nav-container ul') // Account for nexstar-wv sites.
  || document.querySelector('.site-footer__primary-nav ul') // Use primary nav as backup.
  || document.querySelector('.site-footer__secondary-nav ul'); // Check secondary nav as backup.

const FooterLinkPortal = ({ children }) => {
  if (! mount) {
    return null;
  }

  const loginLinkRef = useRef(null);
  const getLoginLink = useCallback(() => {
    if (null === loginLinkRef.current) {
      loginLinkRef.current = document.createElement('li');
      loginLinkRef.current.classList.add('footer-adobe-primetime-login');
    }
    return loginLinkRef.current;
  }, [loginLinkRef]);

  useEffect(() => {
    mount.appendChild(getLoginLink());

    return () => {
      mount.removeChild(getLoginLink());
    };
  }, [getLoginLink, mount]);

  return createPortal(children, getLoginLink());
};

FooterLinkPortal.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FooterLinkPortal;
